import React, { Component } from "react"
import WizardModalContent from "./shared/WizardModalContent"
import i18n from 'lib/i18n'
import styles from './ClaimWizard.scss'

// variables out of module
const _ = i18n('claimWizard')

function ClaimWarningModal(props) {
    const { modalTitle, message } = props

    return (
        <WizardModalContent modalTitle={modalTitle}>
            <div className={styles.modalFormContent}>
                <div className={styles.sectionWrapper}>
                    <span className={styles.message}>{message}</span>
                </div>
                {props.children}
            </div>
        </WizardModalContent>
    )
}

export default ClaimWarningModal



// WEBPACK FOOTER //
// ./components/ClaimsWizard/ClaimWarningModal.jsx